import { matchSorter } from 'match-sorter';
import dayjs from 'dayjs';

const DATETIME_FORMAT = 'YYYY/MM/DD HH:mm';

export function createBundlesDataColumns() {
  const columns = [
    {
      id: 'bundleId',
      Header: 'bundleId',
      accessor: 'bundleId',
      minWidth: 70,
      maxWidth: 80,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['bundleId'] }),
      filterAll: true,
    },
    {
      id: 'created',
      Header: 'created',
      accessor: c => {
        return dayjs(c.created).format(DATETIME_FORMAT);
      },
      minWidth: 40,
      maxWidth: 80,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['created'] }),
      filterAll: true,
    },
    {
      id: 'region',
      Header: 'region',
      accessor: 'region',
      minWidth: 40,
      maxWidth: 80,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['region'] }),
      filterAll: true,
    },
    {
      id: 'courierName',
      Header: 'courierName',
      accessor: 'courierName',
      minWidth: 120,
      maxWidth: 200,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['courierName'] }),
      filterAll: true,
    },
    {
      id: 'travelMode',
      Header: 'travelMode',
      accessor: 'travelMode',
      minWidth: 120,
      maxWidth: 200,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['travelMode'] }),
      filterAll: true,
    },

    {
      id: 'carType',
      Header: 'carType',
      accessor: 'carType',
      minWidth: 120,
      maxWidth: 200,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['carType'] }),
      filterAll: true,
    },

    {
      id: 'orderCount',
      Header: 'Total orders',
      accessor: 'orderCount',
      minWidth: 80,
      maxWidth: 150,
      filterAll: true,
    },
    {
      id: 'deliveryCount',
      Header: 'Total Deliveries',
      accessor: 'deliveryCount',
      minWidth: 80,
      maxWidth: 150,
      filterAll: true,
    },
    {
      id: 'meterdriven',
      Header: 'distanceMeters',
      accessor: c => {
        return c.measures.distanceMeters;
      },
      minWidth: 80,
      maxWidth: 150,
    },
    {
      id: 'durationSeconds',
      Header: 'durationSeconds',
      accessor: c => {
        return c.measures.durationSeconds;
      },
      minWidth: 80,
      maxWidth: 150,
    },
    {
      id: 'drivingTimeSeconds',
      Header: 'drivingTimeSeconds',
      accessor: c => {
        return c.measures.drivingTimeSeconds;
      },
      minWidth: 80,
      maxWidth: 150,
    },
    {
      id: 'waitingTimeSeconds',
      Header: 'waitingTimeSeconds',
      accessor: c => {
        return c.measures.waitingTimeSeconds;
      },
      minWidth: 80,
      maxWidth: 150,
    },
    {
      id: 'firstDeliveryEta',
      Header: 'First Delivery Eta',
      accessor: c => {
        return dayjs(c.firstDeliveryEta).format(DATETIME_FORMAT);
      },
      minWidth: 100,
      maxWidth: 180,
    },
    {
      id: 'lastDeliveryEta',
      Header: 'Last Delivery Eta',
      accessor: c => {
        return dayjs(c.lastDeliveryEta).format(DATETIME_FORMAT);
      },
      minWidth: 140,
      maxWidth: 180,
    },
    {
      id: 'firstDeliveryTime',
      Header: 'First Delivery Time',
      accessor: c => {
        return dayjs(c.firstDeliveryTime).format(DATETIME_FORMAT);
      },
      minWidth: 140,
      maxWidth: 180,
    },
    {
      id: 'lastDeliveryTime',
      Header: 'Last Delivery Time',
      accessor: c => {
        return dayjs(c.lastDeliveryTime).format(DATETIME_FORMAT);
      },
      minWidth: 140,
      maxWidth: 180,
    },
    {
      id: 'zones',
      Header: 'zones',
      accessor: c => {
        return c.zones.join(',');
      },
      minWidth: 140,
      maxWidth: 180,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['zones'] }),
      filterAll: true,
    },
  ];
  return columns;
}
